<template>
  <div :class="{'has-logo':showLogo}" class="left-menu">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <transition name="el-zoom-in-center">
        <el-menu
          v-if="menuSwitch"
          :default-active="activeMenu"
          :background-color="variables.menuBg"
          :text-color="variables.menuText"
          :unique-opened="false"
          :active-text-color="variables.menuActiveText"
          :collapse-transition="false"
          mode="vertical"
        >
          <div v-for="route in permission_routes" :key="route.path">
            <sidebar-item v-if="route.type === permission_routesType || route.type === '*'" :item="route" :base-path="route.path" />
          </div>
        </el-menu>
      </transition>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem },
  data() {
    return {
      menuSwitch: true
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'permission_routesType',
      'user_message',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  watch: {
    permission_routesType(newValue, oldValue) {
      this.menuSwitch = false
      // 寻找符合条件的第一个路由
      const path = this.permission_routes.filter(_ => {
        return !_.hidden && _.type === newValue
      })
      const pathType = this.$route.path.split('/')[1].toUpperCase()
      setTimeout(() => {
        this.menuSwitch = true
        let data = null
        if (path.length > 0 && path[0].children && path[0].children.length > 0) {
          data = {
            redirect: path[0].path + '/' + path[0].children[0].path,
            type: path[0].type
          }
        }
        if (data && pathType !== this.permission_routesType) {
          this.$router.push(data.redirect)
        }
      }, 300)
      // 更改对应平台的角色权限
      if (this.user_message.user_info.super_manager !== 1) {
        // 非超管需要更改用户信息权限
        const levelInfo = this.user_message[newValue.toLowerCase()].level_info
        this.$store.dispatch('user/setModuleUserLevel', levelInfo)
      }
    },
    $route(newValue) {
      const data = this.getRouterModule(newValue)
      this.setRouterType(data)
    }
  },
  created() {
    const data = this.getRouterModule(this.$route)
    this.setRouterType(data)
  },
  methods: {
    ...mapActions(['user/setModuleUserLevel']),
    getRouterModule(route) {
      const reg = /\d+$/g
      let path = route.path.split('/')
      // 针对下钻 下钻路径后面很多数字
      path = path.map(_ => {
        return _.replace(reg, '')
      })
      path = path[path.length - 3] + '/' + path[path.length - 2]
      const data = this.permission_routes.filter(_ => {
        return _.path === '/' + path
      })
      return data
    },
    setRouterType(data) {
      if (data.length > 0 && data[0].type !== '*') {
        this.$store.dispatch('permission/changeRouterType', data[0].type)
      }
    }
  }
}
</script>

<style lang="scss">
.left-menu{
  .el-submenu__title,.el-scrollbar{
    background-color: #313d4c!important;
  }
}
</style>
